import { isAdminRoute } from '../routes/adminRoutes';

const ADMIN_BG = '#0a0a0a';

/** Keep html/body/#root dark on /admin/* even if React fails before painting. */
export function applyAdminDocumentTheme(pathname) {
  if (typeof document === 'undefined') return;
  const onAdmin = isAdminRoute(pathname);
  const { documentElement: html, body } = document;
  const root = document.getElementById('root');

  if (onAdmin) {
    html.classList.add('admin-route');
    body.classList.add('admin-route');
    html.style.backgroundColor = ADMIN_BG;
    body.style.backgroundColor = ADMIN_BG;
    if (root) root.style.backgroundColor = ADMIN_BG;
    return;
  }

  html.classList.remove('admin-route');
  body.classList.remove('admin-route');
  html.style.backgroundColor = '';
  body.style.backgroundColor = '';
  if (root) root.style.backgroundColor = '';
}
